/* unplugin-vue-components disabled */import script from "./Layouts.vue?vue&type=script&setup=true&lang=js"
export * from "./Layouts.vue?vue&type=script&setup=true&lang=js"

import "./Layouts.vue?vue&type=style&index=0&id=43bf5395&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bf5395"]])

export default __exports__